import { render, staticRenderFns } from "./Tip2.vue?vue&type=template&id=b8c9fcd6&scoped=true"
import script from "./Tip2.vue?vue&type=script&lang=js"
export * from "./Tip2.vue?vue&type=script&lang=js"
import style0 from "./Tip2.vue?vue&type=style&index=0&id=b8c9fcd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c9fcd6",
  null
  
)

export default component.exports